import livro from '../../img/livro.png'
import livro2 from '../../img/livro2.png'
import livroSenhor from '../../img/livroSenhorDosAneis.png'
import livroHarry from '../../img/livroHarryPotter.jpg'

export const livros = [
  { nome: 'Shrek', src: livroHarry, id: 1 },
  { nome: 'Harry Potter 4', src: livro, id: 2 },
  { nome: 'Victor Hugo', src: livroSenhor, id: 3 },
]

export const livrosRecomendacao = {
  nome: 'Angular 11',
  descricao: 'Contruindo páginas dinâmicas usando Google',
  src: livro2,
  id: 1,
}
